<template>
  <footer class="service-footer">
    <div class="service-footer-top">
      <p>
        今すぐ無料ではじめてみる
      </p>
      <div class="btns-wrapper">
        <template v-if="!signedIn">
          <proa-service-button
            class="sign-up"
            variant="outline-primary round"
            text="無料アカウントを作成"
            @click.native="routerPush('signUp')"
          />
        </template>
        <template v-else>
          <proa-service-button
            class="sign-up"
            variant="outline-primary round"
            text="マイスペース"
            @click.native="routerPush('mySpace')"
          />
        </template>
      </div>
    </div>
    <div class="service-footer-bottom">
      <div class="service-footer-bottom-inner">
        <div class="logo-wrapper clickable" @click="toServiceTop()">
          <p class="text-service">
            <span class="d-block">いつもの</span>
            <span class="d-block">コミュニケーションを</span>
            <span class="d-block">いつでも</span>
          </p>
          <img :src="require('@/assets/images/logo.png')" alt="logo" />
        </div>
        <div class="menu-wrapper">
          <ul>
            <li @click="toServiceTop">
              トップ
            </li>
            <li @click="routerPush('serviceAbout')">
              初めての方
            </li>
            <li @click="routerPush('serviceFeatures')">
              機能一覧
            </li>
            <li @click="routerPush('servicePlans')">
              料金プラン
            </li>
            <li @click="routerPush('indexServiceNotifications')">
              お知らせ
            </li>
          </ul>
          <ul>
            <li @click="toOperatingCompany">
              運営会社
            </li>
            <li @click="routerPush('serviceContact')">
              お問い合わせ
            </li>
            <li @click="routerPush('servicePrivacyPolicy')">
              個人情報取扱規定
            </li>
            <li @click="routerPush('serviceTermsOfService')">
              利用規約
            </li>
            <!-- TODO -->
            <!-- <li>
              特定商取引法に基づく表記
            </li> -->
          </ul>
        </div>
      </div>
      <div class="copy-wrapper">
        <p class="copy">
          Copyright © 2021 IWATSU ELECTRIC CO., LTD. All Rights Reserved.
        </p>
      </div>
    </div>
  </footer>
</template>

<script>

export default {
  name: 'ServiceFooter',
  props: {
    signedIn: {
      type: Boolean,
      default: false
    },
    route: {
      type: String,
      default: 'service'
    }
  },
  methods: {
    routerPush: function(route = null) {
      if (this.route == route) return
      if (!route) {
        this.$router.push({ name: 'root' })
      } else {
        this.$router.push({ name: `${route}` })
      }
    },
    toServiceTop: function() {
      if (this.$route.name === 'service') return
      this.$router.push({ name: 'service' })
    },
    toOperatingCompany: function() {
      open('https://www.iwatsu.co.jp/', '_blank');
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";
@import "@/styles/mediaquery";

.service-footer {
  width: 100vw;

  &-top {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: $service-primary-color;
    padding: 57px 0 74px 0;

    p {
      color: #fff;
      font-size: 22px;
      font-weight: 600;
      margin-bottom: 40px;

      @include mq(md) {
        font-size: 26px;
      }
    }

    .btns-wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;

      @include mq(md) {
        flex-direction: row;
        justify-content: center;
      }

      .sign-up {
        margin-bottom: 20px;

        @include mq(md) {
          margin-bottom: 0;
          margin-right: 20px;
        }
      }

    }
  }

  &-bottom {
    background-color: $background-color;
    padding: 20px;

    @include mq(md) {
      padding: 67px 50px 83px 50px;
    }

    &-inner {
      display: flex;
      flex-direction: column;
      margin-bottom: 65px;

      @include mq(md) {
        flex-direction: row;
        justify-content: space-between;
        max-width: 1070px;
        margin: 0 auto;
      }

      .logo-wrapper {
        margin-bottom: 40px;
        transition: all .2s;

        @include mq(md) {
          margin-bottom: 0;
        }

        &:hover {
          opacity: .6;
        }

        p {
          font-size: 15px;
          font-weight: 600;
          margin-bottom: 15px;
        }

        img {
          width: 160px;
        }
      }

      .menu-wrapper {
        display: flex;
        justify-content: space-between;
        max-width: 444px;

        @include mq(md) {
          width: 444px;
        }

        ul {
          margin: 0;
          padding: 0;


          li {
            list-style: none;
            cursor: pointer;
            color: $service-grey-text-color;
            font-size: 14px;
            margin-bottom: 15px;
            transition: all .2s;

            &:hover {
              opacity: .6;
            }

            &:last-child{
              margin-bottom: 0;
            }
          }
        }
      }
    }

    .copy-wrapper {
      margin-top: 65px;

      .copy {
        text-align: center;
        font-size: 11px;
        color: $service-grey-text-color;
      }
    }
  }
}
</style>
